import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Anagrafica } from 'src/app/entities/various';
import { ConfigServiceService, ItemSelectProps } from 'src/app/services/config-service/config-service.service';
import { Address as AddressValidator } from 'src/app/entities/Address';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.css']
})
export class PersonalDataComponent implements OnInit {
  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Input() json_sdi_data : string | undefined;
  @Output() change : EventEmitter<Anagrafica> = new EventEmitter();

  pdata : Anagrafica | undefined;

  regimi : ItemSelectProps[] = [];
  soci : ItemSelectProps[] = [] ;
  liq : ItemSelectProps[] = [];

  section : string = 'sede';
  iban_aggiuntivi :any[]=[];

  easyMode :boolean = true;
  public addressHelper=new AddressValidator();
  
  constructor(private configService: ConfigServiceService) {
    this.innerWidth = window.innerWidth;
   }

  async ngOnInit(){
    let list = (await this.configService.getJSON()).list;
    this.regimi = list.listRegimeFiscale;
    this.soci = list.listSocioUnico;
    this.liq = list.listStatoLiquidazione;
    this.pdata = JSON.parse(this.json_sdi_data!);
    this.pdata!.DatiAnagrafici.IdFiscaleIVA.IdPaese = 'IT';
    if(!Array.isArray(this.pdata?.iban_aggiuntivi))
            this.pdata!.iban_aggiuntivi= [];
    else{
      this.pdata!.iban_aggiuntivi.forEach((row)=>{
        this.iban_aggiuntivi.push({value:row,confirmed:true});
      });

    }
    
  }

  emitData() {
    this.change.emit(this.pdata);    
  }

  getJsonAnagrafica(){
    return this.pdata;
  }

  goTo(tab : string) {
    this.section = tab;
  }

  setCreatedData(company_name : string,vatcode : string,taxcode : string){
    if (vatcode != "") {
      this.pdata!.DatiAnagrafici.IdFiscaleIVA.IdCodice=vatcode;
    }
    if (taxcode != "") {
      this.pdata!.DatiAnagrafici.CodiceFiscale = taxcode;
    }
    this.pdata!.DatiAnagrafici.Anagrafica.Denominazione = company_name;
  }

  changeEasyMode(){
    if(!this.easyMode){
      this.pdata!.DatiAnagrafici.Anagrafica.CodEORI='';
      this.pdata!.DatiAnagrafici.AlboProfessionale='';
      this.pdata!.DatiAnagrafici.ProvinciaAlbo='';
      this.pdata!.DatiAnagrafici.NumeroIscrizioneAlbo='';
      this.pdata!.DatiAnagrafici.DataIscrizioneAlbo='';

      this.pdata!.StabileOrganizzazione.Indirizzo='';
      this.pdata!.StabileOrganizzazione.NumeroCivico='';
      this.pdata!.StabileOrganizzazione.Comune='';
      this.pdata!.StabileOrganizzazione.CAP='';
      this.pdata!.StabileOrganizzazione.Provincia='';
      this.pdata!.StabileOrganizzazione.Nazione='';

      this.pdata!.IscrizioneREA.Ufficio='';
      this.pdata!.IscrizioneREA.CapitaleSociale='';
      this.pdata!.IscrizioneREA.SocioUnico='';
      this.pdata!.IscrizioneREA.StatoLiquidazione='';
      this.pdata!.IscrizioneREA.NumeroREA='';
      this.goTo('sede');
    }
    this.easyMode=!this.easyMode;
  }

  pulisciDatiTipoAnagrafica(){
    //console.log(this.pdata!.DatiAnagrafici.Anagrafica);
    if(this.pdata!.DatiAnagrafici.Anagrafica.PersonaFisica){
            this.pdata!.DatiAnagrafici.Anagrafica.Titolo="";
            this.pdata!.DatiAnagrafici.Anagrafica.Cognome="";
            this.pdata!.DatiAnagrafici.Anagrafica.Cognome="";
    }else{
        this.pdata!.DatiAnagrafici.Anagrafica.Denominazione="";
    }
  }

  aggiungiIban(){
      this.iban_aggiuntivi!.push({value:'',confirmed:false});
  }


  /**************************/
  aggiungiIbanAggiuntivo(){
    let found= this.iban_aggiuntivi.filter((row)=> row.confirmed==false);
      if(found.length > 0 )
            return;
      this.iban_aggiuntivi.push({value:'',confirmed:false});
  }

  confermaIbanAggiuntivo(index: number){
    if(this.iban_aggiuntivi[index].value == '')
        return;
      if(this.pdata!.iban_aggiuntivi![index]!=undefined)
        this.pdata!.iban_aggiuntivi![index]=this.iban_aggiuntivi[index].value;
      else
        this.pdata!.iban_aggiuntivi!.push(this.iban_aggiuntivi[index].value);
      this.iban_aggiuntivi[index].confirmed=true;
  }

  modificaIbanAggiuntivo(index:number){
      let found= this.iban_aggiuntivi.filter((row)=> row.confirmed==false);
      if(found.length > 0 )
            return;
      this.iban_aggiuntivi[index].confirmed=false;
  }


  esisteIbanNonConfermato(){
    let found= this.iban_aggiuntivi.filter((row)=> row.confirmed==false);
      if(found.length > 0 )
            return true;
    return false;
  }


  rimuoviIbanAggiuntivo(index :number){
          this.iban_aggiuntivi.splice(index,1);
          this.pdata!.iban_aggiuntivi!.splice(index,1);
  }
  controllaIbanPrincipale(){
    if(this.pdata?.iban==''){
          this.pdata!.iban_aggiuntivi=[];
          this.iban_aggiuntivi=[];
  }

  }

}
